module.exports = __webpack_public_path__ + "img/127d03fc.swf";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Video/jwplayer/jwplayer.flash.swf
 ** module id = 59
 ** module chunks = 0
 **/